module.exports = __webpack_public_path__ + "img/ogp_alquimia_big.b129c120.jpg";